import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=0e0fc1ef&scoped=true&lang=pug"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0fc1ef",
  null
  
)

export default component.exports